import {
  ACTION_GET_REQUESTING,
  ACTION_SET_BEST,
  ACTION_GET_ALL_LIST_REQUESTING,
  ACTION_GET_SELECTION_LIST_REQUESTING,
  ACTION_UPDATE_SELECTION_REQUESTING,
  ACTION_CHECK,
  ACTION_SELECT_TAB,
  ACTION_CLOSE_SNACK_MESSAGE,
  ACTION_CREATION_MODIFY,
  ACTION_CREATE_REQUESTING,
  ACTION_GET_PRIVATE_REQUESTING,
  ACTION_DELETE_PRIVATE_REQUESTING,
  ACTION_MODIFY_PRIVATE_REQUESTING,
  ACTION_GET_SELECTED_REQUESTING
} from "./constants";

export const getBestActionsRequest = (payload: {}) => {
  return {
    type: ACTION_GET_REQUESTING,
    payload
  };
};

export const setBestActions = payload => {
  return {
    type: ACTION_SET_BEST,
    payload
  };
};

export const getAllActionsListRequest = () => {
  return {
    type: ACTION_GET_ALL_LIST_REQUESTING
  };
};

export const getSelectionListRequest = payload => {
  return {
    type: ACTION_GET_SELECTION_LIST_REQUESTING,
    payload
  };
};

export const checkAction = payload => {
  return {
    type: ACTION_CHECK,
    payload
  };
};

export const updateSelectionRequest = (payload: {
  clientId: string,
  actionsSelected: []
}) => {
  return {
    type: ACTION_UPDATE_SELECTION_REQUESTING,
    payload
  };
};

export const selectTab = (payload: number) => {
  return {
    type: ACTION_SELECT_TAB,
    payload
  };
};

export const closeSnackMessage = () => {
  return {
    type: ACTION_CLOSE_SNACK_MESSAGE
  };
};

export const modifyCreation = (payload: {}) => {
  return {
    type: ACTION_CREATION_MODIFY,
    payload
  };
};

export const createActionRequest = payload => {
  return {
    type: ACTION_CREATE_REQUESTING,
    payload
  };
};

export const getMyActionsCreatedRequest = payload => {
  return {
    type: ACTION_GET_PRIVATE_REQUESTING,
    payload
  };
};

export const deletePrivateActionRequest = payload => {
  return {
    type: ACTION_DELETE_PRIVATE_REQUESTING,
    payload
  };
};

export const modifyPrivateActionRequest = payload => {
  return {
    type: ACTION_MODIFY_PRIVATE_REQUESTING,
    payload
  };
};

export const getActionsSelectedRequest = payload => {
  return {
    type: ACTION_GET_SELECTED_REQUESTING,
    payload
  };
};

export const deleteActionRequest = payload => {
  return {
    type: ACTION_DELETE_PRIVATE_REQUESTING,
    payload
  };
};
